const APP_PACKAGE_PICKER_BASE_URL = 'https://www.wix.com/apps/upgrade/';
const PARAM_META_SITE_ID = 'metaSiteId';
const PARAM_PP_ORIGIN = 'pp_origin';
const PARAM_RENDER_IN_MODAL = 'render_in_modal';
const DEFAULT_PP_ORIGIN_VALUE = 'app_market_app_page';

export function getAppPackagePickerUrl({
  appId,
  metaSiteId,
  isModalEnabled,
  ppOrigin,
}: {
  appId: string;
  metaSiteId: string;
  isModalEnabled: boolean;
  ppOrigin?: string;
}) {
  const appPackagePickerUrl = new URL(`${APP_PACKAGE_PICKER_BASE_URL}${appId}`);
  appPackagePickerUrl.searchParams.set(PARAM_META_SITE_ID, metaSiteId);
  appPackagePickerUrl.searchParams.set(
    PARAM_PP_ORIGIN,
    ppOrigin || DEFAULT_PP_ORIGIN_VALUE,
  );
  if (isModalEnabled) {
    appPackagePickerUrl.searchParams.set(PARAM_RENDER_IN_MODAL, 'true');
  }
  return appPackagePickerUrl.toString();
}
